import { UserInfo } from "@/models/userInfo.model";
import { create } from "zustand";

interface UserInfoState {
  user: UserInfo;
  setUser: (user: UserInfo) => void;
}

export const useUserInfo = create<UserInfoState>((set) => ({
  user: {
    name: undefined,
    document: undefined,
    phone: undefined
  },
  setUser: (user: UserInfo) => set({ user })
}));
